export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  createdAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  longDescription: string;
  categories: string[];
  tags: string[];
  rating: number;
  ratingCount: number;
  status: '连载中' | '已完结';
  totalChapters: number;
  chapters: ComicChapter[];
  views: number;
  likes: number;
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有韩国漫画作品' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血激燃的动作漫画' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line', description: '引人入胜的剧情漫画' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line', description: '轻松搞笑的日常喜剧' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑作品' },
  { slug: 'school', name: '校园', icon: 'ri-building-line', description: '青春洋溢的校园故事' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的私密恋爱',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20couple%20sitting%20closely%20on%20a%20park%20bench%20under%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20clean%20lineart%2C%20warm%20spring%20lighting%2C%20anime%20inspired%20art%20style%2C%20gentle%20expressions%2C%20light%20cream%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '青梅竹马的两人，在成年后意外重逢，一段隐秘而甜蜜的办公室恋情悄然展开。',
    longDescription: '从小一起长大的李智恩和朴志勋，因为家庭变故失去了联系。十年后，智恩以新入职员的身份进入了一家知名企业，却发现直属上司竟是儿时的玩伴志勋。在职场规则和个人情感之间，两人开始了隐秘的办公室恋情。然而，公司内部的各种人际关系和竞争，让这段感情充满变数。他们能否在事业与爱情之间找到平衡？',
    categories: ['romance', 'drama'],
    tags: ['办公室恋情', '青梅竹马', '都市', '甜宠'],
    rating: 4.8,
    ratingCount: 12580,
    status: '连载中',
    totalChapters: 86,
    chapters: [],
    views: 2580000,
    likes: 186000,
    updatedAt: '2026-08-04',
    createdAt: '2025-03-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-2',
    title: '剑与魔法学院',
    author: '李东勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20illustration%20of%20a%20magic%20academy%20student%20holding%20a%20glowing%20sword%2C%20fantasy%20setting%20with%20floating%20crystals%2C%20detailed%20costume%20design%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20anime%20art%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '平凡少年意外进入魔法学院，在剑与魔法的世界中开启传奇冒险之路。',
    longDescription: '普通高中生韩宇辰在一次意外中发现自己拥有罕见的双属性魔力，被邀请进入著名的阿尔卡迪亚魔法学院。在这里，他不仅要学习剑术和魔法，还要面对学院内部的权利斗争。随着黑暗势力的逐渐逼近，宇辰必须快速成长，与伙伴们一起守护学院和世界的和平。',
    categories: ['fantasy', 'action'],
    tags: ['魔法', '学院', '冒险', '成长'],
    rating: 4.7,
    ratingCount: 9840,
    status: '连载中',
    totalChapters: 124,
    chapters: [],
    views: 3120000,
    likes: 245000,
    updatedAt: '2026-08-05',
    createdAt: '2024-11-20',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-3',
    title: '社内相亲',
    author: '朴美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20illustration%20of%20an%20office%20worker%20woman%20in%20elegant%20attire%20blushing%20at%20a%20corporate%20event%2C%20romantic%20comedy%20vibe%2C%20soft%20warm%20lighting%2C%20champagne%20glasses%20in%20background%2C%20clean%20lineart%2C%20gentle%20pastel%20tones&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '代替闺蜜参加相亲，却遇到了公司社长！一场啼笑皆非的社内恋爱喜剧。',
    longDescription: '平凡上班族金夏琳接到闺蜜的紧急求助，代替她参加一场相亲。谁知相亲对象竟然是公司新上任的年轻社长车敏浩！为了不被认出，夏琳使出浑身解数伪装自己，却不知道社长早已识破一切。一场充满误会和笑料的社内恋爱就此展开，而更大的秘密还在等待着他们。',
    categories: ['romance', 'comedy'],
    tags: ['办公室恋情', '契约恋爱', '搞笑', '甜宠'],
    rating: 4.9,
    ratingCount: 15320,
    status: '连载中',
    totalChapters: 72,
    chapters: [],
    views: 4200000,
    likes: 312000,
    updatedAt: '2026-08-03',
    createdAt: '2025-06-01',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-4',
    title: '暗黑追踪者',
    author: '郑宇城',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20moody%20Korean%20manhwa%20illustration%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20rainy%20alleyway%20at%20night%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20neon%20reflections%2C%20mysterious%20vibe%2C%20clean%20lineart%2C%20cool%20muted%20tones&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '前刑警成为私家侦探，追踪连环案件背后的惊天阴谋。',
    longDescription: '曾是精英刑警的姜太浩因一次失败的任务引咎辞职，成为私家侦探。当他接手一起看似普通的失踪案时，却发现案件背后隐藏着涉及政商界的庞大犯罪网络。每一条线索都将他引向更深的黑暗，而他的生命也面临着严重威胁。在真相与安全之间，太浩选择了继续追踪。',
    categories: ['thriller', 'action'],
    tags: ['悬疑', '犯罪', '推理', '都市'],
    rating: 4.6,
    ratingCount: 7820,
    status: '连载中',
    totalChapters: 58,
    chapters: [],
    views: 1890000,
    likes: 128000,
    updatedAt: '2026-08-02',
    createdAt: '2025-09-10',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-5',
    title: '我的同桌是校霸',
    author: '尹素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20manhwa%20illustration%20of%20two%20high%20school%20students%20sitting%20at%20a%20classroom%20desk%2C%20one%20looking%20annoyed%20and%20the%20other%20smiling%20brightly%2C%20school%20uniform%2C%20sunlight%20through%20windows%2C%20youthful%20energy%2C%20clean%20lineart%2C%20warm%20colors&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '乖乖女学霸被迫与校霸同桌，却发现他冷酷外表下隐藏的温柔。',
    longDescription: '全校第一的模范生韩素拉被老师安排与校霸尹在赫同桌，美其名曰"帮带学习"。面对这个传闻中打架斗殴、不学无术的校霸，素拉做好了长期斗争的准备。然而随着相处深入，她逐渐发现尹在赫冷漠外表下的另一面——他会默默保护被欺负的同学，会在深夜独自练舞，还有着一个不愿被人知道的梦想。',
    categories: ['school', 'romance'],
    tags: ['校园', '青春', '甜宠', '成长'],
    rating: 4.8,
    ratingCount: 18600,
    status: '连载中',
    totalChapters: 94,
    chapters: [],
    views: 5100000,
    likes: 398000,
    updatedAt: '2026-08-05',
    createdAt: '2025-01-20',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-6',
    title: '重生之女王归来',
    author: '崔多惠',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20illustration%20of%20a%20confident%20woman%20in%20an%20elegant%20red%20dress%20standing%20in%20a%20grand%20ballroom%2C%20revenge%20theme%2C%20luxurious%20setting%2C%20determined%20expression%2C%20dramatic%20lighting%2C%20clean%20lineart%2C%20rich%20warm%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '被最信任的人背叛后重生，这一次她要夺回属于自己的一切。',
    longDescription: '前世的柳书妍是帝国最耀眼的明星，却被丈夫和闺蜜联手陷害，含恨而终。再次睁开眼，发现自己回到了十年前——悲剧尚未发生的时候。带着前世的记忆和对背叛者的刻骨仇恨，书妍开始了精心的复仇计划。但重来一次的人生也出现了一些变数，一个意想不到的人闯入了她的计划。',
    categories: ['drama', 'romance'],
    tags: ['重生', '复仇', '逆袭', '女强'],
    rating: 4.7,
    ratingCount: 11200,
    status: '已完结',
    totalChapters: 110,
    chapters: [],
    views: 3800000,
    likes: 275000,
    updatedAt: '2026-07-15',
    createdAt: '2024-08-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-7',
    title: '九尾狐传',
    author: '安智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20illustration%20of%20a%20nine-tailed%20fox%20spirit%20in%20human%20form%2C%20traditional%20Korean%20hanbok%20with%20modern%20twist%2C%20mystical%20glowing%20tails%2C%20moonlit%20forest%20background%2C%20ethereal%20atmosphere%2C%20fantasy%20art%20style%2C%20warm%20amber%20tones&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '千年九尾狐伪装成人类生活在现代都市，一段跨越人妖界限的奇幻爱情。',
    longDescription: '修行千年的九尾狐白灵儿为了完成最后的修行，来到人类世界生活。她以插画师的身份在首尔过着平凡生活，直到遇见了能够看到她的尾巴的普通人类男子韩志浩。按照天界的规则，被人类发现真身的妖怪必须被消除记忆或返回灵界。但白灵儿发现自己越来越无法离开这个特别的人类，而天界的追兵也在步步逼近。',
    categories: ['fantasy', 'romance'],
    tags: ['九尾狐', '奇幻', '爱情', '都市'],
    rating: 4.9,
    ratingCount: 14300,
    status: '连载中',
    totalChapters: 68,
    chapters: [],
    views: 4650000,
    likes: 352000,
    updatedAt: '2026-08-04',
    createdAt: '2025-04-10',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-8',
    title: '极速心跳',
    author: '张民浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20illustration%20of%20a%20street%20racer%20leaning%20against%20a%20sports%20car%20at%20night%2C%20city%20lights%20in%20background%2C%20racing%20theme%2C%20cool%20attitude%2C%20action%20packed%2C%20clean%20lineart%2C%20vibrant%20neon%20accents&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '地下赛车界的传说与新晋天才车手之间的速度对决与热血青春。',
    longDescription: '地下赛车界有一个无人不知的传说——"夜鹰"。没有人知道他的真实身份，只知道他从未输过。大学生郑允浩因一次偶然机会接触到了地下赛车，凭借惊人的天赋迅速崭露头角。当新星遇上传说，一场关于速度与荣誉的热血对决即将展开。而在这条危险的赛道上，友情的羁绊和爱情的火花也在同时燃烧。',
    categories: ['action', 'drama'],
    tags: ['赛车', '热血', '青春', '竞技'],
    rating: 4.5,
    ratingCount: 6320,
    status: '连载中',
    totalChapters: 45,
    chapters: [],
    views: 1320000,
    likes: 89000,
    updatedAt: '2026-08-01',
    createdAt: '2026-02-15',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-9',
    title: '甜蜜的谎言',
    author: '韩素英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20tender%20Korean%20manhwa%20illustration%20of%20a%20couple%20sharing%20earphones%20while%20walking%20on%20a%20snowy%20street%2C%20winter%20romance%2C%20cozy%20scarves%2C%20soft%20snowflakes%2C%20warm%20streetlights%2C%20clean%20lineart%2C%20gentle%20pastel%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '为了守护一个善意的谎言，她不得不开始一段虚假的恋爱关系。',
    longDescription: '为了不让病重的奶奶担心，大学生林多恩撒了一个谎——她说自己已经有了男朋友。没想到奶奶突然说自己要来首尔看孙女婿。情急之下，多恩请求学校里有名的暖男学长权泰宇假扮自己的男朋友。本应是一周的临时恋爱，却在相处中产生了真实的情感。然而，谎言总有被揭穿的一天。',
    categories: ['romance', 'drama'],
    tags: ['假戏真做', '暖男', '治愈', '校园'],
    rating: 4.8,
    ratingCount: 10800,
    status: '已完结',
    totalChapters: 80,
    chapters: [],
    views: 2950000,
    likes: 218000,
    updatedAt: '2026-06-20',
    createdAt: '2025-02-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-10',
    title: '鬼差大人有点萌',
    author: '宋允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20manhwa%20illustration%20of%20a%20clumsy%20grim%20reaper%20in%20modern%20casual%20clothes%20holding%20a%20smartphone%2C%20comedy%20fantasy%2C%20mist%20in%20background%2C%20funny%20expression%2C%20clean%20lineart%2C%20warm%20soft%20colors&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '新上任的鬼差在人间闹出各种乌龙事件，搞笑又温情的奇幻日常。',
    longDescription: '阴间新上任的鬼差444号（人送外号"小四"）被派到人间执行任务。但由于业务不熟练，他总是在执行任务时闹出各种乌龙——把生魂当死魂带走、被人类当成cosplayer、甚至不小心救了一个本该死去的女孩。按照规定这是严重违规，但小四发现自己和这个人类女孩之间产生了奇怪的联系。一场跨越阴阳两界的搞笑奇幻日常就此展开。',
    categories: ['comedy', 'fantasy'],
    tags: ['鬼差', '搞笑', '治愈', '奇幻'],
    rating: 4.6,
    ratingCount: 8650,
    status: '连载中',
    totalChapters: 52,
    chapters: [],
    views: 2100000,
    likes: 156000,
    updatedAt: '2026-08-03',
    createdAt: '2025-11-08',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-11',
    title: '皇后的品格',
    author: '赵恩静',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20regal%20Korean%20manhwa%20illustration%20of%20a%20queen%20in%20magnificent%20traditional%20palace%20robes%2C%20standing%20in%20a%20royal%20court%2C%20determined%20gaze%2C%20historical%20fantasy%2C%20intricate%20details%2C%20warm%20golden%20lighting%2C%20clean%20lineart&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '平民女子被卷入宫廷斗争，以智慧和勇气在权力旋涡中生存。',
    longDescription: '出身平凡的崔素媛因一次偶然被选入宫中，成为了国王的妃子。在权力斗争的旋涡中心，她经历了背叛、陷害，但也收获了真挚的友情和爱情。从天真单纯的少女到运筹帷幄的皇后，素媛用自己的智慧和善意改变着这个腐朽的宫廷。但当国家面临外敌入侵时，她必须做出最艰难的抉择。',
    categories: ['drama', 'fantasy'],
    tags: ['宫廷', '权谋', '逆袭', '历史'],
    rating: 4.7,
    ratingCount: 9200,
    status: '已完结',
    totalChapters: 96,
    chapters: [],
    views: 2750000,
    likes: 192000,
    updatedAt: '2026-05-30',
    createdAt: '2024-12-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-12',
    title: '放学后的秘密',
    author: '李瑞妍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20illustration%20of%20two%20students%20in%20a%20school%20hallway%20after%20sunset%2C%20one%20holding%20a%20notebook%2C%20golden%20hour%20light%20through%20windows%2C%20youthful%20mystery%2C%20clean%20lineart%2C%20warm%20amber%20glow&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '放学后的社团活动室里，一群少年少女之间发生的青涩秘密。',
    longDescription: '秀雅高中有一个神秘的"放学后社团"，成员们每天放学后聚集在旧教学楼的活动室里。据说加入这个社团的人都会得到一个秘密任务。转学生文智秀误打误撞加入了社团，发现每个成员都有着不为人知的烦恼和秘密。在帮助彼此解决问题的过程中，他们建立了深厚的友谊，也迎来了各自的成长与蜕变。',
    categories: ['school', 'drama'],
    tags: ['校园', '青春', '成长', '友情'],
    rating: 4.5,
    ratingCount: 5400,
    status: '连载中',
    totalChapters: 36,
    chapters: [],
    views: 980000,
    likes: 72000,
    updatedAt: '2026-08-04',
    createdAt: '2026-04-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
];

// Generate chapters for each comic
comics.forEach((comic) => {
  const chapterCount = comic.totalChapters;
  const chapters: ComicChapter[] = [];
  for (let i = chapterCount; i >= 1; i--) {
    const date = new Date(comic.createdAt);
    date.setDate(date.getDate() + (chapterCount - i) * 3);
    chapters.push({
      id: `${comic.id}-ch-${i}`,
      title: i === 1 ? '第1话' : `第${i}话`,
      number: i,
      createdAt: date.toISOString().split('T')[0],
    });
  }
  comic.chapters = chapters;
});

export const getHotComics = (): Comic[] => comics.filter((c) => c.isHot);
export const getNewComics = (): Comic[] => comics.filter((c) => c.isNew);
export const getRecommendedComics = (): Comic[] => comics.filter((c) => c.isRecommended);
export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categories.includes(slug));
};
export const getComicById = (id: string): Comic | undefined => comics.find((c) => c.id === id);

export const rankingComics = [...comics]
  .sort((a, b) => b.views - a.views)
  .slice(0, 10);